<template>
    <div style="width:55px; height: 55px;" class="bg-light-gray flex items-center justify-around">
            <div class="flex">
                <h6>{{ rating }}</h6>
                <img class="pl1" src="@/assets/img/icon_star.svg"/>
            </div>
        </div>

</template>

<script>
export default {
    props: {
        rating: {
            type: Number,
            required: true
        }
    }
};
</script>
